import { createContext } from 'react';

// ----------------------------------------------------------------------

export const EntityContext = createContext({});
